/* customize-tabs-mg.js — Text, Monogram & Popular Images tabs for MG Custom Image Editor */
(function () {
  'use strict';
  var wrapper = document.getElementById('customize-mg-wrapper');
  if (!wrapper) return;

  var cropSize = parseInt(wrapper.dataset.cropWidth) || 380;

  /* ── Tab switching ─────────────────────────────────── */
  MG.tabs = {};
  MG.tabs.active = 'upload';

  MG.tabs.switchTo = function (tabName) {
    MG.tabs.active = tabName;
    var tabs = document.querySelectorAll('.mg-tab-btn');
    var panels = document.querySelectorAll('.mg-tab-panel');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.toggle('mg-tab-active', tabs[i].dataset.tab === tabName);
    }
    for (var j = 0; j < panels.length; j++) {
      if (panels[j].id === 'tab-' + tabName) {
        panels[j].style.display = panels[j].classList.contains('mg-text-grid') ? 'grid' : 'block';
      } else {
        panels[j].style.display = 'none';
      }
    }
    // Only show footer (Save/Close) on the upload/editor tab
    var footer = document.getElementById('mg-footer');
    if (footer) footer.style.display = (tabName === 'upload') ? 'flex' : 'none';
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mg-tab-btn');
    if (btn && btn.dataset.tab) MG.tabs.switchTo(btn.dataset.tab);
  });

  /* ── Shared: render text onto a square canvas ──────── */
  function renderText(lines, fontFamily, fontColor, bgColor, size, isMonogram) {
    var canvas = document.getElementById('mg-text-canvas');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'mg-text-canvas';
      canvas.style.display = 'none';
      document.body.appendChild(canvas);
    }
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');

    // Background
    ctx.fillStyle = bgColor || '#ffffff';
    ctx.fillRect(0, 0, size, size);

    // Filter empty lines
    var active = [];
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].trim()) active.push(lines[i]);
    }
    if (active.length === 0) return canvas;

    ctx.fillStyle = fontColor || '#000000';
    ctx.textAlign = 'center';

    if (isMonogram) {
      return renderMonogramOnCanvas(ctx, active[0], fontFamily, fontColor, size, canvas);
    }

    // Dynamic font sizing — shrink until all lines fit within 75% of canvas width
    var maxW = size * 0.75;
    var fontSize = Math.floor(size * 0.35);
    var minFont = 14;

    while (fontSize > minFont) {
      ctx.font = fontSize + 'px ' + fontFamily;
      var allFit = true;
      for (var k = 0; k < active.length; k++) {
        if (ctx.measureText(active[k]).width > maxW) { allFit = false; break; }
      }
      if (allFit) break;
      fontSize -= 2;
    }

    ctx.font = fontSize + 'px ' + fontFamily;
    ctx.textBaseline = 'middle';
// this is the code to control the line height
    var lineH = fontSize * 1;
    var totalH = active.length * lineH;
    var startY = (size - totalH) / 2 + lineH / 2;

    for (var m = 0; m < active.length; m++) {
      ctx.fillText(active[m], size / 2, startY + m * lineH);
    }

    return canvas;
  }

  /* ── Monogram: 3 chars using positional Monogramos fonts ─ */
  // Font names injected via @font-face in customize-mg.liquid
  var MONO_FONTS = ['MonogramosLeft', 'MonogramosCenter', 'MonogramosRight'];

  function renderMonogramOnCanvas(ctx, text, fontFamily, fontColor, size, canvas) {
    var chars = text.substring(0, 3).toUpperCase();
    if (chars.length === 0) return canvas;

    ctx.fillStyle = fontColor || '#000000';
    ctx.textBaseline = 'alphabetic';

    // Large size — well above 1.0 because font em-square has heavy internal padding
    var fontSize = Math.floor(size * 1.35);

    // Build array of {char, font} per position
    var glyphs = [];
    for (var i = 0; i < chars.length && i < 3; i++) {
      var fn = MONO_FONTS[i] || MONO_FONTS[1];
      if (chars.length === 1) fn = MONO_FONTS[1];
      else if (chars.length === 2) fn = (i === 0) ? MONO_FONTS[0] : MONO_FONTS[2];
      glyphs.push({ ch: chars[i], font: fn });
    }

    // Measure total width — zero spacing, glyphs designed to sit next to each other
    var totalW = 0;
    for (var g = 0; g < glyphs.length; g++) {
      ctx.font = fontSize + 'px ' + glyphs[g].font;
      glyphs[g].width = ctx.measureText(glyphs[g].ch).width;
      totalW += glyphs[g].width;
    }

    // Shrink only if truly overflowing canvas (pixel scan handles clipping)
    var maxW = size * 1.8;
    if (totalW > maxW) {
      fontSize = Math.floor(fontSize * (maxW / totalW));
      totalW = 0;
      for (var s = 0; s < glyphs.length; s++) {
        ctx.font = fontSize + 'px ' + glyphs[s].font;
        glyphs[s].width = ctx.measureText(glyphs[s].ch).width;
        totalW += glyphs[s].width;
      }
    }

    // Render once off-center, then measure actual pixel bounds to re-center
    var tmpCanvas = document.createElement('canvas');
    tmpCanvas.width = size * 2;
    tmpCanvas.height = size * 2;
    var tmp = tmpCanvas.getContext('2d');
    tmp.fillStyle = fontColor || '#000000';
    tmp.textBaseline = 'alphabetic';
    var tx = size * 0.5;
    var ty = size * 1.2;
    for (var t = 0; t < glyphs.length; t++) {
      tmp.font = fontSize + 'px ' + glyphs[t].font;
      tmp.fillText(glyphs[t].ch, tx, ty);
      tx += glyphs[t].width;
    }
    // Scan pixels for actual bounding box
    var pix = tmp.getImageData(0, 0, tmpCanvas.width, tmpCanvas.height).data;
    var minX = tmpCanvas.width, maxX = 0, minY = tmpCanvas.height, maxY = 0;
    for (var py = 0; py < tmpCanvas.height; py++) {
      for (var px = 0; px < tmpCanvas.width; px++) {
        if (pix[(py * tmpCanvas.width + px) * 4 + 3] > 20) {
          if (px < minX) minX = px;
          if (px > maxX) maxX = px;
          if (py < minY) minY = py;
          if (py > maxY) maxY = py;
        }
      }
    }
    // Compute shift to move visual center of temp rendering to real canvas center
    var visualCenterX = (minX + maxX) / 2;
    var visualCenterY = (minY + maxY) / 2;
    var shiftX = (size / 2) - visualCenterX;
    var shiftY = (size / 2) - visualCenterY;

    // Apply shift to the original temp drawing positions (with manual nudge)
    var cx = (size * 0.5) + shiftX + (size * 0.17);
    var drawY = (size * 1.2) + shiftY + 2;
    for (var d = 0; d < glyphs.length; d++) {
      ctx.font = fontSize + 'px ' + glyphs[d].font;
      ctx.fillText(glyphs[d].ch, cx, drawY);
      cx += glyphs[d].width;
    }

    return canvas;
  }

  /* ── Apply rendered canvas to the cropper ──────────── */
  MG.tabs.applyCanvas = function (canvas) {
    if (!canvas) return;
    var dataUrl = canvas.toDataURL('image/png');
    MG.cropper.cropper.replace(dataUrl, false);
    MG.tabs.switchTo('upload');
  };

  /* ── Text tab: live preview + Apply ────────────────── */
  MG.tabs.updateTextPreview = function () {
    var l1 = document.getElementById('mg-text-line1');
    var l2 = document.getElementById('mg-text-line2');
    var l3 = document.getElementById('mg-text-line3');
    var font = document.getElementById('mg-text-font');
    var fc = document.getElementById('mg-text-fcolor');
    var bg = document.getElementById('mg-text-bgcolor');
    if (!l1) return;

    var lines = [l1.value, l2.value, l3.value];
    var fontFamily = font ? font.value : 'Arial';
    var fontColor = fc ? fc.value : '#000000';
    var bgColor = bg ? bg.value : '#ffffff';

    var canvas = renderText(lines, fontFamily, fontColor, bgColor, cropSize, false);
    showPreview('mg-text-preview', canvas);
  };

  MG.tabs.applyText = function () {
    MG.tabs.updateTextPreview();
    var canvas = document.getElementById('mg-text-canvas');
    MG.tabs.applyCanvas(canvas);
  };

  /* ── Monogram tab: live preview + Apply ────────────── */
  MG.tabs.updateMonogramPreview = function () {
    var input = document.getElementById('mg-mono-input');
    var fc = document.getElementById('mg-mono-fcolor');
    var bg = document.getElementById('mg-mono-bgcolor');
    if (!input) return;

    var text = input.value.substring(0, 3);
    var fontColor = fc ? fc.value : '#000000';
    var bgColor = bg ? bg.value : '#ffffff';

    var canvas = renderText([text], 'MonogramosCenter', fontColor, bgColor, cropSize, true);
    showPreview('mg-mono-preview', canvas);
  };

  MG.tabs.applyMonogram = function () {
    MG.tabs.updateMonogramPreview();
    var canvas = document.getElementById('mg-text-canvas');
    MG.tabs.applyCanvas(canvas);
  };

  /* ── Preview helper ────────────────────────────────── */
  function showPreview(previewId, canvas) {
    var el = document.getElementById(previewId);
    if (!el || !canvas) return;
    // Draw circular preview
    var prev = document.createElement('canvas');
    var sz = el.clientWidth || 200;
    prev.width = sz;
    prev.height = sz;
    var pctx = prev.getContext('2d');
    pctx.beginPath();
    pctx.arc(sz / 2, sz / 2, sz / 2, 0, Math.PI * 2);
    pctx.closePath();
    pctx.clip();
    pctx.drawImage(canvas, 0, 0, sz, sz);

    el.innerHTML = '';
    el.appendChild(prev);
  }

  /* ── Popular images: click to load into cropper ────── */
  MG.tabs.selectPopular = function (url) {
    MG.cropper.cropper.replace(url, false);
    MG.tabs.switchTo('upload');
  };

  document.addEventListener('click', function (e) {
    var img = e.target.closest('.mg-popular-img');
    if (img && img.dataset.src) {
      MG.tabs.selectPopular(img.dataset.src);
    }
  });

  /* ── Symbol modal: toggle open/close ─────────────── */
  MG.tabs.activeTextInput = null;

  function toggleSymPopup(forceClose) {
    var modal = document.getElementById('mg-sym-popup');
    if (!modal) return;
    if (forceClose || modal.classList.contains('mg-sym-popup-open')) {
      modal.classList.remove('mg-sym-popup-open');
    } else {
      // Reset to bottom-center each time it opens
      modal.style.left = '50%';
      modal.style.top = '';
      modal.style.bottom = '20px';
      modal.style.transform = 'translateX(-50%)';
      modal.classList.add('mg-sym-popup-open');
    }
  }

  /* ── Symbol modal: drag by header ──────────────────── */
  (function () {
    var dragging = false, startX, startY, startLeft, startTop;

    function onStart(e) {
      var handle = document.getElementById('mg-sym-drag-handle');
      if (!handle) return;
      var target = e.touches ? e.target : e.target;
      if (!target.closest('#mg-sym-drag-handle') || target.closest('#mg-sym-popup-close')) return;

      var modal = document.getElementById('mg-sym-popup');
      if (!modal) return;
      dragging = true;

      var rect = modal.getBoundingClientRect();
      // Switch from bottom-center to top-left positioning for drag
      modal.style.left = rect.left + 'px';
      modal.style.top = rect.top + 'px';
      modal.style.bottom = 'auto';
      modal.style.transform = 'none';

      var pt = e.touches ? e.touches[0] : e;
      startX = pt.clientX;
      startY = pt.clientY;
      startLeft = rect.left;
      startTop = rect.top;
      e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;
      var modal = document.getElementById('mg-sym-popup');
      if (!modal) return;
      var pt = e.touches ? e.touches[0] : e;
      var dx = pt.clientX - startX;
      var dy = pt.clientY - startY;
      var newLeft = Math.max(0, Math.min(window.innerWidth - modal.offsetWidth, startLeft + dx));
      var newTop = Math.max(0, Math.min(window.innerHeight - modal.offsetHeight, startTop + dy));
      modal.style.left = newLeft + 'px';
      modal.style.top = newTop + 'px';
      e.preventDefault();
    }

    function onEnd() { dragging = false; }

    document.addEventListener('mousedown', onStart);
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchstart', onStart, { passive: false });
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onEnd);
  })();

  document.addEventListener('click', function (e) {
    // Symbol modal trigger
    var symTrigger = e.target.closest('#mg-sym-trigger');
    if (symTrigger) {
      e.preventDefault();
      toggleSymPopup();
      return;
    }

    // Symbol modal close button
    if (e.target.closest('#mg-sym-popup-close')) {
      e.preventDefault();
      toggleSymPopup(true);
      return;
    }

    // Emoji keyboard trigger
    var emojiBtn = e.target.closest('.mg-emoji-btn');
    if (emojiBtn) {
      e.preventDefault();
      var input = MG.tabs.activeTextInput || document.getElementById('mg-text-line1');
      if (input) input.focus();
      var hint = document.getElementById('mg-emoji-hint');
      if (hint) {
        var isMac = /Mac|iPhone|iPad/.test(navigator.userAgent);
        hint.textContent = isMac ? 'Press Ctrl+Cmd+Space' : 'Press Win + . (period)';
        hint.style.display = 'block';
        setTimeout(function () { hint.style.display = 'none'; }, 4000);
      }
      return;
    }

    // Symbol insertion from modal
    var btn = e.target.closest('.mg-sym-btn');
    if (!btn || !btn.dataset.sym) return;
    e.preventDefault();

    var input = MG.tabs.activeTextInput || document.getElementById('mg-text-line1');
    if (!input) return;

    var sym = btn.dataset.sym;
    var max = parseInt(input.getAttribute('maxlength')) || 0;
     if (max && input.value.length + sym.length > max) return;
    var pos = input.selectionStart || input.value.length;
    input.value = input.value.substring(0, pos) + sym + input.value.substring(pos);
    var newPos = pos + sym.length;
    input.focus();
    input.setSelectionRange(newPos, newPos);

    // Trigger preview update
    MG.tabs.updateTextPreview();
  });

  /* ── Debounced input listeners (attached after DOM ready) ── */
  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }

  function attachListeners() {
    // Text fields
    var textIds = ['mg-text-line1', 'mg-text-line2', 'mg-text-line3', 'mg-text-font', 'mg-text-fcolor', 'mg-text-bgcolor'];
    var lineIds = ['mg-text-line1', 'mg-text-line2', 'mg-text-line3'];
    var debouncedText = debounce(MG.tabs.updateTextPreview, 150);
    for (var i = 0; i < textIds.length; i++) {
      var el = document.getElementById(textIds[i]);
      if (el) el.addEventListener('input', debouncedText);
    }

    // Track active text input for symbol insertion
    for (var li = 0; li < lineIds.length; li++) {
      var lineEl = document.getElementById(lineIds[li]);
      if (lineEl) lineEl.addEventListener('focus', function () { MG.tabs.activeTextInput = this; });
    }

    // Monogram fields (no font dropdown — uses fixed Monogramos font)
    var monoIds = ['mg-mono-input', 'mg-mono-fcolor', 'mg-mono-bgcolor'];
    var debouncedMono = debounce(MG.tabs.updateMonogramPreview, 150);
    for (var j = 0; j < monoIds.length; j++) {
      var mel = document.getElementById(monoIds[j]);
      if (mel) mel.addEventListener('input', debouncedMono);
    }

    // Monogram: allow only A-Z, max 3 chars
    var monoInput = document.getElementById('mg-mono-input');
    if (monoInput) {
      monoInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^a-zA-Z]/g, '').substring(0, 3);
      });
    }

    // Apply buttons
    var applyText = document.getElementById('mg-apply-text');
    if (applyText) applyText.addEventListener('click', MG.tabs.applyText);

    var applyMono = document.getElementById('mg-apply-mono');
    if (applyMono) applyMono.addEventListener('click', MG.tabs.applyMonogram);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }
})();
